import { createContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode'; // ✅ correcta


export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    if (token) {
      const decoded = jwtDecode(token);
      const extractedRoles = decoded.roles?.map(r => r.authority || r) || [];
      setRoles(extractedRoles);
    } else {
      setRoles([]);
    }
  }, [token]);

  const login = (jwt) => {
    localStorage.setItem('token', jwt);
    setToken(jwt);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setRoles([]);
  };

  return (
    <AuthContext.Provider value={{ token, roles, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
